import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    common: {
      send: 'Send',
      missingRequiredFields: 'Required fields are missing',
      missingRequiredField: 'Required field',
    },
  },
  ru: {
    common: {
      send: 'Отправить',
      missingRequiredFields: 'Не заполнены обязательные поля',
      missingRequiredField: 'Обязательное поле',
    },
  },
  fr: {
    common: {
      send: 'Envoyer',
      missingRequiredFields: 'Les champs obligatoires sont manquants',
      missingRequiredField: 'Champ obligatoire',
    },
  },
  es: {
    common: {
      send: 'Enviar',
      missingRequiredFields: 'Faltan campos obligatorios',
      missingRequiredField: 'Campo obligatorio',
    },
  },
  de: {
    common: {
      send: 'Senden',
      missingRequiredFields: 'Erforderliche Felder fehlen',
      missingRequiredField: 'Pflichtfeld',
    },
  },
}

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

export const i18n = new VueI18n({
  locale: params.lang || 'en',
  messages,
})
